var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-tabs',[_c('b-tab',[_c('template',{slot:"title"},[_c('i',{staticClass:"fa fa-comment-o",staticStyle:{"font-size":"15px"}})]),_vm._v(" "),_c('transaction-note-component')],2),_vm._v(" "),_c('b-tab',[_c('template',{slot:"title"},[_c('i',{staticClass:"fa fa-dollar"})]),_vm._v(" "),_c('cobranca-component')],2)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-17813cc5","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/containers/DefaultAside.vue
// module id = null
// module chunks = 